/**
 * The tenant's own word for a domain object, as i18next interpolation
 * variables.
 *
 * Catalogue copy carries slots (`{{warrantyNounLower}}`) instead of the
 * platform's word, and the tenant's words arrive on the org-context payload
 * (`vocabulary`). One global string with a slot replaces ~100 per-tenant
 * override rows; see docs/tenant-vocabulary.md.
 */

export type Vocabulary = Record<string, string>;

/**
 * The platform's own words, used until the org context lands and on surfaces
 * that have no tenant at all (login, staff login). Without them an unresolved
 * slot renders as an empty string.
 *
 * Only the nouns the catalogue actually uses. The backend is the source of
 * truth - `test_vocabulary_guardrails` fails if these drift from it.
 */
export const PLATFORM_VOCABULARY: Vocabulary = {
  warrantyNoun: "Warranty",
  warrantyNounPlural: "Warranties",
  warrantyNounLower: "warranty",
  warrantyNounPluralLower: "warranties",
  holdingNoun: "Registration",
  holdingNounPlural: "Registrations",
  holdingNounLower: "registration",
  holdingNounPluralLower: "registrations",
  claimNoun: "Claim",
  claimNounPlural: "Claims",
  claimNounLower: "claim",
  claimNounPluralLower: "claims",
  partnerNoun: "Partner",
  partnerNounPlural: "Partners",
  partnerNounLower: "partner",
  partnerNounPluralLower: "partners",
};
